import Container from "./SectionComponents/Container";
import Section from "./SectionComponents/Section";
import SectionWithContainer from "./SectionComponents/SectionWithContainer";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer";
import LazyLoadedVideo from "./LazyLoadedVideo";
import SEOVideo from "./video/SEOVideo";
import Map from "./Map/Map";
import Button from "./Button";
import PopupForm from "./PopupForm";
import Call from "./ContactButton/Call";
import Whatsapp from "./ContactButton/WhatsApp";
import Faq from "./Faq";
import GuestReviews from "./GuestReviews";
import { Heading, Paragraph } from "@/components/TextAndInputComponents";
import GreetingCard from "./cards/GreetingCard";
import Videocard from "./video/Videocard";
import OurJourneyCard from "./cards/OurJourneyCard";
import NearByCard from "./cards/NearByCard";
import NearByCard2 from "@/components/cards/NearByCard2";
import DoAtHotelCard from "./cards/DoAtHotelCard";
import Form from "./Form";
import HomeRoomCard from "./cards/HomeRoomCard";
export {
  Container,
  Section,
  SectionWithContainer,
  Navbar,
  Footer,
  LazyLoadedVideo,
  SEOVideo,
  Map,
  PopupForm,
  Call,
  Whatsapp,
  Button,
  Faq,
  GuestReviews,
  Heading,
  Paragraph,
  GreetingCard,
  Videocard,
  OurJourneyCard,
  NearByCard,
  NearByCard2,
  DoAtHotelCard,
  Form,
  HomeRoomCard,
};
